import { render, staticRenderFns } from "./DeleteMarketText.vue?vue&type=template&id=18908a38"
import script from "./DeleteMarketText.vue?vue&type=script&lang=js"
export * from "./DeleteMarketText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports